import { render, staticRenderFns } from "./VenueInfoForm.vue?vue&type=template&id=bf71db26&scoped=true&"
import script from "./VenueInfoForm.vue?vue&type=script&lang=js&"
export * from "./VenueInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./VenueInfoForm.vue?vue&type=style&index=0&id=bf71db26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf71db26",
  null
  
)

export default component.exports